import AirDatepicker from "air-datepicker";
import { addQueryParamsToUrl } from "../lib/utils";

const $calendarInput = $(".js-search-panel-calendar-input");
const $periodBtn = $(".js-select-current-btn");

const removeFirstNullFromDayDate = (val) => {
  let dates = val.split(" - ");
  let clearDates = "";

  $.each(dates, function (i, el) {
    let elFigures = el.split(".");
    let clearDate = "";

    $.each(elFigures, function (k, elFigure) {
      if (elFigure.charAt(0) === "0") {
        if (k === 0) {
          clearDate = `${elFigure.slice(1)}.`;
        } else {
          if (k === elFigures.length - 1) {
            clearDate = clearDate + `${elFigure.slice(1)}`;
          } else {
            clearDate = clearDate + `${elFigure.slice(1)}.`;
          }
        }
      } else {
        if (k === 0) {
          clearDate = elFigure;
        } else {
          if (k === elFigures.length - 1) {
            clearDate = clearDate + `${elFigure}`;
          } else {
            clearDate = clearDate + `${elFigure}.`;
          }
        }
      }
    });

    if (i === 0) {
      clearDates = clearDate;
    } else {
      clearDates = clearDates + ` - ${clearDate}`;
    }
  });

  return clearDates;
};

export const calendarFunctions = () => {
  const airDateOptions = {
    keyboardNav: true,
  };

  let applyBtn = {
    content: "Применить",
    className: "btn btn--primary btn--fluid js-datepicker-apply-btn",
    onClick: () => {
      let fromDatePicker = searchDatePicker.selectedDates[0];
      let toDatePicker;

      if (!searchDatePicker.selectedDates[1]) {
        toDatePicker = fromDatePicker;
      } else {
        toDatePicker = searchDatePicker.selectedDates[1];
      }

      let from = new Date(fromDatePicker);
      from = `${from.getDate()}.${from.getMonth() + 1}.${from.getFullYear()}`;

      let to = new Date(toDatePicker);
      to = `${to.getDate()}.${to.getMonth() + 1}.${to.getFullYear()}`;

      searchDatePicker.hide();

      $periodBtn.text(removeFirstNullFromDayDate($calendarInput.val()));
      addQueryParamsToUrl({ from: from, to: to }, "range");
    },
  };

  const searchDatePicker = new AirDatepicker(
    ".js-search-panel-calendar-input",
    {
      ...airDateOptions,
      buttons: [applyBtn],
      range: true,
      multipleDatesSeparator: " - ",
      position: "bottom right",
      prevHtml: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m17.793 9.5-7.147-7.146.707-.708L19.707 10l-8.354 8.354-.707-.707 7.147-7.147H2v-1h15.793Z" fill="#000"/></svg>`,
      nextHtml: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m17.793 9.5-7.147-7.146.707-.708L19.707 10l-8.354 8.354-.707-.707 7.147-7.147H2v-1h15.793Z" fill="#000"/></svg>`,
    }
  );
};
